export default {"src":"/_next/static/media/icone-helio.8232056a.svg","height":40,"width":44,"blurWidth":0,"blurHeight":0};